import { animate, state, style, transition, trigger } from '@angular/animations';
import { Component, OnInit, ViewChild } from '@angular/core';
import { MatButtonToggleChange } from '@angular/material/button-toggle';
import { PageEvent } from '@angular/material/paginator';
import { MatSnackBar } from '@angular/material/snack-bar';
import { MatTable } from '@angular/material/table';
import { Title } from '@angular/platform-browser';
import { ActivatedRoute, Router } from '@angular/router';
import { MtxDialog } from '@ng-matero/extensions/dialog';
import { ChannelDto } from 'src/app/models/channel-dto';
import { AuthService } from 'src/app/services/auth-service.service';
import { ChannelsService } from 'src/app/services/channels.service';
import { LogService } from 'src/app/services/log.service';
import { environment } from 'src/environments/environment';

@Component({
	selector: 'app-channels',
	templateUrl: './channels.component.html',
	styleUrls: ['./channels.component.scss'],
	animations: [
		trigger('detailExpand', [
			state('collapsed', style({ height: '0px', minHeight: '0' })),
			state('expanded', style({ height: '*' })),
			transition('expanded <=> collapsed', animate('225ms cubic-bezier(0.4, 0.0, 0.2, 1)')),
		]),
	],
})
export class ChannelsComponent implements OnInit {
	loading!: boolean;
	displayedColumns: string[] = ['name'];

	list: ChannelDto[] = [];
	listLength!: number;
	page!: number;
	pageSize!: number;

	expandedChannel!: ChannelDto | null;

	isChecked!: boolean;

	@ViewChild(MatTable) table!: MatTable<ChannelDto>;

	constructor(
		private titleService: Title,
		private activatedRoute: ActivatedRoute,
		private router: Router,
		private dialog: MtxDialog,
		private snackBar: MatSnackBar,
		private logService: LogService,
		private channelsService: ChannelsService,
		private authService: AuthService
	) {
		this.titleService.setTitle(`${environment.title} | Canales`);

		this.page = 0;
		this.pageSize = environment.paging.size;

		this.loading = false;
	}

	async ngOnInit(): Promise<void> {
		try {
			await this.getChannels();
		} catch (e) {
			this.logService.logError(e as Error);
		}
	}

	async getChannels(): Promise<void> {
		try {
			this.loading = true;

			this.list = await this.channelsService.getChannels(this.page, this.pageSize);
			this.listLength = await this.channelsService.getChannelsLength();

			this.table.renderRows();
		} catch (e) {
			this.logService.logError(e as Error);
		} finally {
			this.loading = false;
		}
	}

	async pageChanged(pageEvent: PageEvent): Promise<void> {
		try {
			this.page = pageEvent.pageIndex;
			this.pageSize = pageEvent.pageSize;

			await this.getChannels();
		} catch (e) {
			this.logService.logError(e as Error);
		}
	}

	onToggleGroupChange(event: MatButtonToggleChange): void {
		try {
			event.source.value = null;
			this.isChecked = false;
		} catch (e) {
			this.logService.logError(e as Error);
		}
	}

	goToUpdate(channel: ChannelDto): void {
		try {
			this.router.navigate([`/channels/${channel.id}`]);
		} catch (e) {
			this.logService.logError(e as Error);
		}
	}
}
